import HasLoadingState from './HasLoadingState';

export default {
    mixins: [
        HasLoadingState
    ],
    props: {
        autoUpdateExternalFilter: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            required: false,
            default: ''
        },
        route: {
            type: String,
            required: true,
        },
        autoLoad: {
            type: Boolean,
            default: false
        },
        filters: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },
    data(){
        return {
            loadingMsg: 'Loading...',
            notFoundMsg: 'Sem resultados',
            orderByTemplate: 'Ordenar por {field}',
            settings: {},
            data: [],
        }
    },
    computed: {
        urlParams() {
            let params = {}
            const filters = this.filters;
            params['filter'] = filters;
            Object.assign(params, this.extraQueryParams);
            return params;
        },
        extraQueryParams() {
            let params = {};
            return params;
        },
        queryParams() {
            return {
                params: this.urlParams,
            }
        },
    },
    async mounted() {
        await this.request();
    },
    methods: {
        async request() {
            if(!this.autoLoad) return;
            if(this.isLoading()) return;
            this.loading(true);
            await this.$http.get(this.route, this.queryParams).then(({data}) => {
                this.data = data.data ? data.data : [];
            }).finally(() => {
                this.loading(false);
            }).catch((error) => {
                this.showError(error)
            })
        },
        showError: function(error) {
            this.$root.$helper.error.httpError(error);
        },
    },
    watch:{
        'filters': {
            handler(newValue){
                this.request();
            },
            deep: true,
        },
    },
}
